import { render, staticRenderFns } from "./PagePlaceholder.vue?vue&type=template&id=31315ea6"
import script from "./PagePlaceholder.vue?vue&type=script&lang=js"
export * from "./PagePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./PagePlaceholder.vue?vue&type=style&index=0&id=31315ea6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports